import { createAsyncThunk } from "@reduxjs/toolkit";
import { getOutstandingPdcReportApi } from "../../../apiservice/accounts";

export const fetchOutstandingPdc = createAsyncThunk(
  "outstandingPdc/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getOutstandingPdcReportApi({});

      return res.data || { banks: [], rows: [], grand_starting_total: 0, grand_closing_total: 0 };
    } catch (err) {
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }

      return rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch outstanding PDC report"
      );
    }
  }
);
